import { generateSearchParams } from './url';
import { createAuthHeaders } from '../app/AuthorizationProvider';
// TODO: Use proper KeycloakType once WFM-698 is in place.
// import { KeycloakType } from '../auth/useAuth';

export interface ExportScheduleParams {
  endDateTime?: string;
  startDateTime?: string;
  offset: string;
}

export const exportSchedule = async (
  id: string,
  token: string,
  tenant: string,
  restPath: string,
  params: ExportScheduleParams
): Promise<Response> => {
  const queryParams = generateSearchParams(params);
  const queryParamsSuffix = queryParams ? `?${queryParams}` : '';

  const url = `${restPath}scheduling/schedule-export/${id}${queryParamsSuffix}`;
  const requestBody = {
    method: 'GET',
    headers: {
      ...createAuthHeaders(token, tenant),
    },
  };

  return fetch(url, requestBody);
};

export const downloadBlobFile = async (response: Response, name = '') => {
  const file = await response.blob();
  const contentDispositionHeader = response.headers.get('content-disposition');
  // eslint-disable-next-line no-useless-escape
  const fileNameMatch = contentDispositionHeader && contentDispositionHeader.match(/attachment\; filename\=(.*)/);
  const fileName = (fileNameMatch && fileNameMatch[1]) || '';

  const anchor = document.createElement('a');
  const blobUrl = window.URL.createObjectURL(file);
  anchor.href = blobUrl;
  anchor.download = name || fileName;
  anchor.target = '_blank';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
